import React from "react";
import ReportView from "../components/ReportView";
import { Tag, fmt } from "../components/UI";

const columns = [
  { key: "order_ref", label: "Order ID", filter: "text", render: (r) => <span className="font-mono text-[11px]">{r.order_ref || "—"}</span> },
  { key: "physio_name", label: "Given to (Physio)", filter: "text" },
  { key: "clinic_name", label: "Clinic", filter: "text", render: (r) => r.clinic_name || "—" },
  { key: "mobile", label: "Mobile", filter: "text", render: (r) => r.mobile || "—" },
  { key: "erp_outlet_id", label: "ERP Outlet ID", filter: "text", render: (r) => r.erp_outlet_id || "—" },
  { key: "sample_name", label: "Sample given", filter: "text", render: (r) => r.sample_name || r.sample_sku || "—" },
  { key: "qty", label: "Qty", align: "right", render: (r) => fmt(r.qty) },
  { key: "given_on", label: "When given", filter: "text", render: (r) => r.given_on || "—" },
  { key: "physio_status", label: "Physio status", filter: "select", options: ["Active", "Inactive"],
    render: (r) => <Tag tone={r.physio_status === "Active" ? "emerald" : "slate"}>{r.physio_status}</Tag> },
  { key: "beat", label: "Beat", filter: "text", render: (r) => r.beat || "—" },
  { key: "dse", label: "DSE", filter: "text", render: (r) => r.dse || "—" },
];

const monthOf = (s) => (s ? String(s).slice(0, 7) : null);

const charts = [
  { id: "smp-trend", type: "area", title: "Samples over time", subtitle: "Monthly samples given", valueLabel: "Samples", groupBy: (r) => monthOf(r.given_on), sort: "time", color: "#B45309" },
  { id: "smp-status", type: "donut", title: "Physio status", valueLabel: "Samples", groupBy: (r) => r.physio_status },
  { id: "smp-top", type: "bar", title: "Top samples by quantity", valueLabel: "Qty", groupBy: (r) => r.sample_name, value: (r) => r.qty || 0, sort: "value_desc", limit: 10, labelWidth: 130 },
];

export default function SampleReport() {
  return (
    <ReportView
      kicker="Field Assist · Samples"
      title="Sample Report"
      subtitle="Every free sample given to physios (Field Assist orders where PTR × order value = 0). Shows the sample, quantity, whom it was given to, when, and whether that physio is Active or Inactive."
      fetchPath="/reports/samples"
      syncPath="/integrations/field-assist/sync"
      statusPath="/integrations/field-assist/status"
      columns={columns}
      charts={charts}
      searchableKeys={["order_ref", "physio_name", "mobile", "erp_outlet_id", "sample_name", "beat"]}
      exportFilename="sample-report"
      testId="sample-report"
      syncLabel="Sync samples"
    />
  );
}
